// Tours with a `resumable` step. Kept out of the registry so a reload after
// some other tour was left doesn't download every tour to find nothing.
export const RESUMABLE_TOUR_KEYS: ReadonlySet<string> = new Set([
  "connect_channels",
]);
